import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";

import {
  drawerWidth,
  mainLayoutStyles,
  showNotification,
} from "../../../../../constants";
import Header from "../../../../../common/Header";
import {
  FilterSection,
  GAUsersTable,
  SearchBar,
} from "../../components/components";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import { useUsersContext } from "../../../../../providers/OrganizationAdmin/UsersProvider";
import { contributorsSearch } from "../../../../../modules/Contributors/hooks/ContributorsHook";
import { getFilterGAUsers, updateUser } from "../../hooks/GAUsersHooks";
import { Toast } from "../../../../../common/alert";
import { disableUserFunction } from "../../../../../firebase";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import FilterModalComponent from "../../../../../common/FilterModalComponent";
import { useCommonContext } from "../../../../../providers/CommonProvider";
import { getDateRange } from "../../../../../modules/OrgProf/hook/Organizationhook";

const GAUsersContainer = () => {
  const { setDateOptionReset } = useCommonContext();
  const { GAUsers, handleGetAllGAUsersWithAnonymous, setLoading, loading } =
    useUsersContext();

  const [allUsers, setAllUsers] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [dateSignupFilterOptions, setDateSignupFilterOptions] = useState([]);
  const [showAnonymousUsers, setShowAnonymousUsers] = useState([
    "Anonymous Disabled",
  ]);
  const [accountStatusFilterOptions, setAccountStatusFilterOptions] = useState(
    []
  );
  const [reportedStatusFilterOptions, setReportedStatusFilterOptions] =
    useState([]);

  const [selected, setSelected] = useState([]);

  useEffect(() => {
    handleGetAllGAUsersWithAnonymous();
  }, []);

  useEffect(() => {
    // setAllUsers(GAUsers);
    if (GAUsers) {
      // Filter out inactive admins by default unless there's a filter explicitly including them
      // if (showAnonymousUsers.length > 0) {
      //   setAllUsers(GAUsers);
      // } else {
      //   const filteredUsers = GAUsers.filter(
      //     (admin) => admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
      //   );
      //   setAllUsers(filteredUsers);
      // }
      if (showAnonymousUsers[0] === "Anonymous Disabled") {
        const filteredUsers = GAUsers.filter(
          (admin) =>
            admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
        );
        setAllUsers(filteredUsers);
      } else {
        setAllUsers(GAUsers);
      }
    }
  }, [GAUsers]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };

  // console.log("show anon:", showAnonymousUsers);

  const handleSearchUsers = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        if (showAnonymousUsers[0] === "Anonymous Disabled") {
          const filteredUsers = GAUsers.filter(
            (admin) =>
              admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
          );
          // setAllUsers(filteredUsers);
          let usersSearchTemp = await contributorsSearch(filteredUsers, value);
          console.log("searched:", usersSearchTemp);
          setAllUsers(usersSearchTemp);
        } else {
          let usersSearchTemp = await contributorsSearch(GAUsers, value);
          console.log("searched:", usersSearchTemp);
          setAllUsers(usersSearchTemp);
        }
      } else {
        // setAllUsers(GAUsers);
        // if (showAnonymousUsers.length > 0) {
        //   setAllUsers(GAUsers);
        // } else {
        //   const filteredUsers = GAUsers.filter(
        //     (admin) => admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
        //   );
        //   setAllUsers(filteredUsers);
        // }
        // const filteredUsers = GAUsers.filter(
        //   (admin) => admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
        // );
        // setAllUsers(filteredUsers);
        if (showAnonymousUsers[0] === "Anonymous Disabled") {
          const filteredUsers = GAUsers.filter(
            (admin) => admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
          );
          setAllUsers(filteredUsers);
        } else {
          setAllUsers(GAUsers);
        }
      }
    } catch (error) {
      console.log("error searching users:", error.message);
    }
  };

  const handleDisableUser = async () => {
    try {
      setLoading(true);
      for (const item of selected) {
        const result = await disableUserFunction({ uid: item });

        // Delete user auth, but do not delete their Firestore doc.
        let temp = {
          isDeleted: true,
          deletedDate: new Date(),
          isActive: false,
        };
        let responseTemp = await updateUser(item, temp);
        // await deleteUser(item);
      }

      // Now fetch all users after disabling them
      await handleGetAllGAUsersWithAnonymous();
      showNotification("User deactivated successfully.");
      setSelected([]);
    } catch (error) {
      Toast("error", error.message);
      console.log("error getting user deleted:", error.message);
    } finally {
      setLoading(false);
      handleDeleteModalClose();
    }
  };

  // const handleDisableUser = async () => {
  //   try {
  //     setLoading(true);
  //     selected.forEach(async (item) => {
  //       const result = await disableUserFunction({ uid: item });

  //       //delete user auth, but do not delete their firestore doc.
  //       let temp = {
  //         isDeleted: true,
  //         deletedDate: new Date(),
  //         isActive: false,
  //       };
  //       let responseTemp = await updateUser(item, temp);
  //       // await deleteUser(item);
  //     });

  //     await handleGetAllGAUsersWithAnonymous();
  //     showNotification("User deactivated successfully.");
  //     setSelected([]);
  //     // Toast("success", "User Deleted successfully.");
  //   } catch (error) {
  //     Toast("error", error.message);
  //     console.log("error getting user deleted:", error.message);
  //   } finally {
  //     setLoading(false);
  //     handleDeleteModalClose();
  //   }
  // };

  // const handleEnableUser = async () => {
  //   try {
  //     setLoading(true);
  //     selected.forEach(async (item) => {
  //       const result = await enableUserFunction({ uid: item });

  //       //delete user auth, but do not delete their firestore doc.
  //       let temp = {
  //         isDeleted: false,
  //         isActive: true,
  //       };
  //       let responseTemp = await updateUser(item, temp);
  //       // await deleteUser(item);
  //     });

  //     await handleGetAllGAUsersWithAnonymous();
  //     showNotification("User activated successfully.");
  //     setSelected([]);
  //     // Toast("success", "User Deleted successfully.");
  //   } catch (error) {
  //     Toast("error", error.message);
  //     console.log("error getting user deleted:", error.message);
  //   } finally {
  //     setLoading(false);
  //     handleDeleteModalClose();
  //   }
  // };

  // const handleDeleteUser = async () => {
  //   try {
  //     setLoading(true);
  //     selected.forEach(async (item) => {
  //       await deleteUserAuth({ text: item });
  //       //delete user auth, but do not delete their firestore doc.
  //       let temp = {
  //         isDeleted: true,
  //         deletedDate: new Date(),
  //         isActive: false,
  //       };
  //       let responseTemp = await updateUser(item, temp);
  //       // await deleteUser(item);
  //     });

  //     await handleGetAllGAUsersWithAnonymous();
  //     showNotification("User deactivated successfully.");
  //     setSelected([]);
  //     // Toast("success", "User Deleted successfully.");
  //   } catch (error) {
  //     Toast("error", error.message);
  //     console.log("error getting user deleted:", error.message);
  //   } finally {
  //     setLoading(false);
  //     handleDeleteModalClose();
  //   }
  // };

  const handleFilterUsers = async () => {
    let dateSignupRange;
    if (dateSignupFilterOptions && dateSignupFilterOptions.length > 0) {
      dateSignupRange = getDateRange(dateSignupFilterOptions, "Date Signup");
    }
    setSelected([]);
    if (
      accountStatusFilterOptions.length > 0 ||
      reportedStatusFilterOptions.length > 0 ||
      dateSignupFilterOptions.length > 0
    ) {
      let temp = await getFilterGAUsers(
        showAnonymousUsers,
        accountStatusFilterOptions,
        reportedStatusFilterOptions,
        dateSignupRange,
        setLoading,
        handleFilterModalClose
      );
      setAllUsers(temp);
    }
    if (
      accountStatusFilterOptions.length === 0 &&
      reportedStatusFilterOptions.length === 0 &&
      dateSignupFilterOptions.length === 0
    ) {
      // setAllUsers(GAUsers);
      // if (showAnonymousUsers.length > 0) {
      //   setAllUsers(GAUsers);
      // } else {
      //   const filteredUsers = GAUsers.filter(
      //     (admin) => admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
      //   );
      //   setAllUsers(filteredUsers);
      // }
      if (showAnonymousUsers[0] === "Anonymous Disabled") {
        const filteredUsers = GAUsers.filter(
          (admin) => admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
        );
        setAllUsers(filteredUsers);
      } else {
        setAllUsers(GAUsers);
      }
    }
  };

  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "dateSignup") {
      setDateSignupFilterOptions([]);
      // setDateSignupFilterOptions((prevOptions) =>
      //   prevOptions.filter((item) => item !== filterItem)
      // );
    } else if (filterType === "accountStatus") {
      setAccountStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "reportedStatus") {
      setReportedStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "Show Anonumous Users") {
      if (filterItem === "Anonymous Disabled") {
        setShowAnonymousUsers(["Anonymous Enabled"]);
      } else {
        setShowAnonymousUsers(["Anonymous Disabled"]);
      }
      // setShowAnonymousUsers((prevOptions) =>
      //   prevOptions.filter((item) => item !== filterItem)
      // );
    }
  };

  useEffect(() => {
    handleFilterUsers();
  }, [
    dateSignupFilterOptions,
    accountStatusFilterOptions,
    reportedStatusFilterOptions,
    showAnonymousUsers,
  ]);

  const resetFilter = async () => {
    setAccountStatusFilterOptions([]);
    setReportedStatusFilterOptions([]);
    setDateSignupFilterOptions([]);
    setDateOptionReset(true);
    // setAllUsers(GAUsers);
    if (showAnonymousUsers[0] === "Anonymous Disabled") {
      const filteredUsers = GAUsers.filter(
        (admin) => admin.firstName !== "Anonymous" && admin.firstName !== "Guest"
      );
      setAllUsers(filteredUsers);
    } else {
      setAllUsers(GAUsers);
    }
    setSelected([]);
  };

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Box sx={{ display: "flex", width: `calc(100% - ${drawerWidth}px)` }}>
      <CssBaseline />
      <Header mainTitle={"Users"} bgColor="#fff" />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            dateSignupFilterOptions={dateSignupFilterOptions}
            accountStatusFilterOptions={accountStatusFilterOptions}
            reportedStatusFilterOptions={reportedStatusFilterOptions}
            showAnonymousUsers={showAnonymousUsers}
            setShowAnonymousUsers={setShowAnonymousUsers}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            selected={selected}
            placeholder={"Search"}
            setSelected={setSelected}
            handleSearch={handleSearchUsers}
            handleDeleteUser={handleDeleteModalOpen}
            handleDisableUser={handleDisableUser}
          />
          <GAUsersTable
            selected={selected}
            setSelected={setSelected}
            allUsers={allUsers}
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDisableUser}
        // handleClick={handleDeleteUser}
        loading={loading}
        title={"Are you sure you want to deactivate the selected user(s)?"}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterUsers}
        data={[
          {
            mainOptions: dateSignupFilterOptions,
            setMainOptions: setDateSignupFilterOptions,
            type: "date",
            title: "Date Signup",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: accountStatusFilterOptions,
            setMainOptions: setAccountStatusFilterOptions,
            type: "text",
            title: "Account Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "active", selected: false },
              { label: "inactive", selected: false },
            ],
          },
          // {
          //   mainOptions: showAnonymousUsers,
          //   setMainOptions: setShowAnonymousUsers,
          //   type: "text",
          //   title: "Show Anonumous Users",
          //   currentOptions: [
          //     // { label: "All", selected: true },
          //     {
          //       label: "Anonymous Disabled",
          //       selected: showAnonymousUsers.length > 0 ? true : false,
          //     },
          //     // { label: "Anonymous Enabled", selected: false },
          //   ],
          // },
          {
            mainOptions: reportedStatusFilterOptions,
            setMainOptions: setReportedStatusFilterOptions,
            type: "text",
            title: "Reported Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "reported", selected: false },
              { label: "in review", selected: false },
              { label: "pending", selected: false },
              { label: "resolved", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default GAUsersContainer;
